import { ConnectDragSource, ConnectDropTarget, useDrag } from "react-dnd";
import * as React from "react";
import { EDragDropObject } from "../EDragDropObject";

export function useDragSource<TDraggableObject>(
    identifier: EDragDropObject,
    draggableObject: TDraggableObject,
    dependencies?: unknown[]
): IDragSourceResult {
    dependencies = dependencies ?? [draggableObject];
    const suppressNextClickRef = React.useRef(false);

    const useDragResult = useDrag(
        () => ({
            type: EDragDropObject[identifier],
            item: draggableObject,
            end: () => {
                suppressNextClickRef.current = true;

                window.setTimeout(() => {
                    suppressNextClickRef.current = false;
                }, 400);
            },
            collect: (monitor) => ({
                isDragging: monitor.isDragging(),
            }),
        }),
        dependencies
    );

    const result: IDragSourceResult = {
        isDragging: useDragResult[0].isDragging,
        dragSourceRef: useDragResult[1],
        consumePostDragClick: () => {
            if (!suppressNextClickRef.current) {
                return false;
            }

            suppressNextClickRef.current = false;
            return true;
        },
    };

    return result;
}

export interface IDragSourceResult {
    isDragging: boolean;
    dragSourceRef: ConnectDragSource;
    consumePostDragClick: () => boolean;
}
